exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".OperationRecord {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n", "", {"version":3,"sources":["D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/OperationRecord.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;CACd","file":"OperationRecord.css","sourcesContent":[".OperationRecord {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/css/OperationRecord.css
// module id = yb2Q
// module chunks = 1